import { addScript } from '../util'
import CookieHelper from '../../utils/CookieHelper'

const sd_pageReady = (dataLayer, landingContext) => {
  let dealer
  if (dataLayer.offer.isStellantisDealer) dealer = 'STELLANTIS'
  if (dataLayer.offer.isToyotaDealer) dealer = 'TOYOTA'
  if (dataLayer.offer.isLexusDealer) dealer = 'LEXUS'
  if (dataLayer.offer.isGMDealer) dealer = 'GMUS'
  if (dataLayer.offer.isGenesisDealer) dealer = 'GENESISUS'
  if (dataLayer.offer.isMazdaDealer) dealer = 'MAZDA'
  if (!dealer) return

  const { globalState } = landingContext
  const {
    environment: { shiftDigitalUrl }
  } = globalState
  const SHIFT_DIGITAL_MAKES = ['STELLANTIS', 'GENESISUS', 'TOYOTA', 'LEXUS', 'GMUS', 'MAZDA']
  const scriptSrc = SHIFT_DIGITAL_MAKES.reduce((acc, make) => {
    acc[make] = `${shiftDigitalUrl}/scripts/${make}/sd.js`
    return acc
  }, {})

  const dealerScriptSrc = scriptSrc[dealer]

  if (!dealerScriptSrc || !dataLayer?.offer?.oemDealerCode) return

  // Remove Shift Digital session cookies before loading the Shift Digital script.
  clearShiftDigitalCookies(dealer, dealerScriptSrc)

  if (addScript(dealerScriptSrc)) {
    window.sd =
      window.sd ||
      function () {
        window.sd.q = window.sd.q || []
        window.sd.q.push(arguments)
      }
    window.sd.l = Date.now()
    window.sd('create', dealer, dataLayer.offer.oemDealerCode, 'KELLEYBLUEBOOKICO')
    window.ICO_isSDLoaded = true
    window.sd('getSessionId', sessionId => (window.sd.SessionId = sessionId))
    const continueTradeIn = dataLayer.session.continueTradeIn
    const isEnableLandingWebComponent = landingContext.usingLandingWebComponent
    if (!continueTradeIn && !isEnableLandingWebComponent) shiftDigital_tradeInImpression(dataLayer)
  }
}

const sd_continue = (dataLayer, globalState, updateGlobalState, landingContext) => {
  const cloneDataLayer = JSON.parse(JSON.stringify(dataLayer))
  if (!window.ICO_isSDLoaded && typeof window.sd !== 'function') return
  try {
    const linkName = cloneDataLayer.pageInfo.linkName
    const pageName = cloneDataLayer.pageInfo.pageName

    switch (pageName) {
      case 'timbuybkcontact':
        if (!globalState.hasFiredTradeInFormInitiation && linkName.includes('tradeInFormInitiation')) {
          shiftDigital_tradeInFormInitiation(cloneDataLayer)
          updateGlobalState({ hasFiredTradeInFormInitiation: true })
        }
        break
      case 'timbuybkthank':
        shiftDigital_tradeInFormSubmission(cloneDataLayer)
        shiftDigital_tradeInComplete(cloneDataLayer)
        break
      case 'timbuybkhome':
        if (!landingContext.usingLandingWebComponent && !globalState.hasFiredTradeInStart) {
          shiftDigital_tradeInStart(cloneDataLayer)
          updateGlobalState({ hasFiredTradeInStart: true })
        }
        if (!globalState.hasFiredTradeInVehicleIndicated) {
          if (linkName.includes('timbuybkhome_selltrade_mileageselect') || linkName.includes('timbuybkhome_selltrade_styleselect') || linkName.includes('continue_timbuybkhome_selltrade_mm')) {
            shiftDigital_tradeInVehicleIndicated(cloneDataLayer)
            updateGlobalState({ hasFiredTradeInVehicleIndicated: true })
          }
        }
        break
      default:
        break
    }
    if (cloneDataLayer.pageInfo.linkName) {
      const linkName = cloneDataLayer.pageInfo.linkName
      if (linkName.includes('submit_request_appointment') || linkName.includes('submit::ico::request-appointment')) {
        shiftDigital_tradeInApptSet(cloneDataLayer)
      }
    }
  } catch (error) {
    console.log('error when push window.dataLayer', error)
  }
}

const getTradeInProvider = dataLayer => {
  return 'KELLEYBLUEBOOKICO'
}

const shiftDigital_tradeInImpression = dataLayer => {
  try {
    if (dataLayer && !window.ICO_StellantistradeInImpression) {
      window.ICO_StellantistradeInImpression = true
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        events: 'tradeInImpression'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('tradeInImpression', e)
  }
}
const shiftDigital_tradeInStart = dataLayer => {
  if (window.ICO_StellantistradeInStart) return
  try {
    window.ICO_StellantistradeInStart = true
    window.sd('dataLayer', {
      tradeInSessionId: dataLayer.session.sessionId,
      tradeInProvider: getTradeInProvider(dataLayer),
      events: 'tradeInStart'
    })
    window.sd('send')
  } catch (e) {
    console.log('sd shiftDigital_tradeInStart', e)
  }
}
const shiftDigital_tradeInVehicleIndicated = dataLayer => {
  try {
    if (supportsShiftDigitalDealer(dataLayer) && dataLayer.session.sessionId) {
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        tradeInYear: dataLayer.vehicle.yearId,
        tradeInMake: dataLayer.vehicle.makeName,
        tradeInModel: dataLayer.vehicle.modelName,
        events: 'tradeInVehicleIndicated'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('shiftDigital_tradeInVehicleIndicated', e)
  }
}
const shiftDigital_tradeInFormInitiation = dataLayer => {
  try {
    if (dataLayer && !window.ICO_StellantistradeInFormInitiation) {
      window.ICO_StellantistradeInFormInitiation = true
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        tradeInYear: dataLayer.vehicle.yearId,
        tradeInMake: dataLayer.vehicle.makeName,
        tradeInModel: dataLayer.vehicle.modelName,
        events: 'tradeInFormInitiation'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('shiftDigital_tradeInFormInitiation', e)
  }
}
const shiftDigital_tradeInFormSubmission = dataLayer => {
  try {
    if (dataLayer && !window.ICO_StellantistradeInFormSubmission) {
      window.ICO_StellantistradeInFormSubmission = true
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        tradeInYear: dataLayer.vehicle.yearId,
        tradeInMake: dataLayer.vehicle.makeName,
        tradeInModel: dataLayer.vehicle.modelName,
        tradeInLeadId: dataLayer.offer.offerId,
        events: 'tradeInFormSubmission'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('shiftDigital_tradeInFormSubmission', e)
  }
}
const shiftDigital_tradeInApptSet = dataLayer => {
  try {
    if (dataLayer) {
      window.tradeInApptSet = true
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        tradeInYear: dataLayer.vehicle.yearId,
        tradeInMake: dataLayer.vehicle.makeName,
        tradeInModel: dataLayer.vehicle.modelName,
        tradeInLeadId: dataLayer.offer.offerId,
        events: 'tradeInApptSet'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('shiftDigital_tradeInApptSet', e)
  }
}
const shiftDigital_tradeInComplete = dataLayer => {
  try {
    if (supportsShiftDigitalDealer(dataLayer) && dataLayer.session.sessionId && !window.ICO_tradeInComplete) {
      window.ICO_tradeInComplete = true
      window.sd('dataLayer', {
        tradeInSessionId: dataLayer.session.sessionId,
        tradeInProvider: getTradeInProvider(dataLayer),
        tradeInYear: dataLayer.vehicle.yearId,
        tradeInMake: dataLayer.vehicle.makeName,
        tradeInModel: dataLayer.vehicle.modelName,
        events: 'tradeInComplete'
      })
      window.sd('send')
    }
  } catch (e) {
    console.log('shiftDigital_tradeInComplete', e)
  }
}

const supportsShiftDigitalDealer = (dataLayer) => {
  return (
    dataLayer.offer.isMazdaDealer ||
    dataLayer.offer.isStellantisDealer ||
    dataLayer.offer.isToyotaDealer ||
    dataLayer.offer.isLexusDealer ||
    dataLayer.offer.isGMDealer ||
    dataLayer.offer.isGenesisDealer
  )
}

// Shift Digital was storing vehicle data (including OEM Dealer Code) in cookies, causing incorrect Dealer Code behavior.
// This function ensures the relevant cookie is removed during initialization to prevent these issues.
const clearShiftDigitalCookies = (dealer, dealerScriptSrc) => {
  // Only remove the cookie if the script isn't present.
  // This handles the case where addScript is called multiple times:
  // On first load with a different dealer, we clear any old cookie before a new one is set.
  const scriptExists = document.querySelector(`script[src*="${dealerScriptSrc}"]`)
  if (!scriptExists) {
    const cookieName = `_sda:${dealer.toLowerCase()}:T3:session`
    CookieHelper.remove(`${cookieName}`, '/', 'kbb.com')
  }
}

export { sd_pageReady, sd_continue }
